import { UserManager, WebStorageStateStore } from 'oidc-client-ts';
import { getConfig } from '../config';

let manager: UserManager | null = null;

/** Lazily created OIDC client for the Keycloak (PKCE, public client) login. */
export function getUserManager(): UserManager {
  if (!manager) {
    const cfg = getConfig();
    manager = new UserManager({
      authority: cfg.oidcIssuer,
      client_id: cfg.oidcClientId,
      redirect_uri: `${window.location.origin}/auth/callback`,
      post_logout_redirect_uri: window.location.origin,
      response_type: 'code',
      scope: 'openid profile email',
      loadUserInfo: false,
      automaticSilentRenew: false,
      userStore: new WebStorageStateStore({ store: window.sessionStorage }),
    });
  }
  return manager;
}
